// Placeholder avatar set — music-themed emoji.
// Each entry has a stable `key` used for storage, an `emoji` for display,
// and a `label` for accessibility. The emoji can later be swapped for image
// URLs by adding an `imageUrl` field and updating the rendering component.
export const AVATARS = [
  { key: 'guitar',      emoji: '🎸', label: 'Guitar' },
  { key: 'piano',       emoji: '🎹', label: 'Piano' },
  { key: 'trumpet',     emoji: '🎺', label: 'Trumpet' },
  { key: 'violin',      emoji: '🎻', label: 'Violin' },
  { key: 'drums',       emoji: '🥁', label: 'Drums' },
  { key: 'saxophone',   emoji: '🎷', label: 'Saxophone' },
  { key: 'microphone',  emoji: '🎤', label: 'Microphone' },
  { key: 'headphones',  emoji: '🎧', label: 'Headphones' },
  { key: 'disco',       emoji: '🪩', label: 'Disco ball' },
  { key: 'vinyl',       emoji: '💿', label: 'Vinyl record' },
  { key: 'notes',       emoji: '🎵', label: 'Music note' },
  { key: 'double_notes',emoji: '🎶', label: 'Music notes' },
];

export const DEFAULT_AVATAR_KEY = 'headphones';

export function getAvatarEmoji(key) {
  return AVATARS.find((a) => a.key === key)?.emoji
    ?? AVATARS.find((a) => a.key === DEFAULT_AVATAR_KEY).emoji;
}
